import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { useApi } from "../lib/api";
import { fmtDate } from "../lib/format";
import { QUOTE_KIND } from "../components/finance/config";

const cell = "border border-black px-2 py-1.5 align-top";
const lines = ["n1", "n2", "n3", "n4"];

function SheetHeader({ d }) {
  return (
    <div className="flex justify-between items-end border-b-2 border-black pb-3 mb-4">
      <div>
        <div className="text-2xl font-extrabold font-heading">ELENCO LAVORAZIONI</div>
        <div className="text-sm font-semibold mt-1" data-testid="print-quote-site">Cantiere {d.site_code} · {d.site_name}</div>
        <div className="text-sm" data-testid="print-quote-title">Oggetto: {d.title}</div>
      </div>
      <div className="text-right text-sm">
        <div>{QUOTE_KIND[d.kind]}{d.number && ` n. ${d.number}`} · rev. {d.revision}</div>
        <div>Data: {fmtDate(d.quote_date)}</div>
      </div>
    </div>
  );
}

function NotesAndSignature() {
  return (
    <div className="mt-8" style={{ breakInside: "avoid" }} data-testid="print-quote-notes">
      <div className="font-semibold text-sm mb-2">Note</div>
      {lines.map((k) => <div key={k} className="border-b border-black h-7" />)}
      <div className="grid grid-cols-2 gap-10 mt-10 text-sm">
        <div><div className="border-b border-black h-10" /><div className="mt-1">Data</div></div>
        <div><div className="border-b border-black h-10" /><div className="mt-1">Firma per ricevuta</div></div>
      </div>
    </div>
  );
}

export default function PrintQuoteWork() {
  const { id } = useParams();
  const { data } = useApi(`/finance/quotes/${id}/work-sheet`);
  if (!data) return <div className="p-10 text-center">Caricamento…</div>;
  return (
    <div className="min-h-screen bg-white text-black print-page" style={{ backgroundImage: "none" }}>
      <style>{"@page { size: A4 portrait; margin: 12mm; }"}</style>
      <div className="no-print sticky top-0 bg-slate-900 text-white p-3 flex justify-between items-center">
        <span className="text-sm">Stampa senza importi — usa "Salva come PDF" nella finestra di stampa</span>
        <button onClick={() => window.print()} className="bg-amber-500 text-slate-950 font-bold px-4 py-2 rounded-md flex items-center gap-2" data-testid="print-quote-now-btn"><Printer className="h-4 w-4" />Stampa / PDF</button>
      </div>
      <div className="p-6 max-w-4xl mx-auto" data-testid="print-quote-sheet">
        <SheetHeader d={data} />
        <table className="w-full text-sm border-collapse">
          <thead><tr className="bg-gray-100"><th className={`${cell} w-10 text-left`}>#</th><th className={`${cell} text-left`}>Lavorazione</th></tr></thead>
          <tbody>
            {data.items.map((it) => (
              <tr key={it.n} style={{ breakInside: "avoid" }} data-testid={`print-quote-item-${it.n}`}>
                <td className={cell}>{it.n}</td><td className={`${cell} whitespace-pre-line`}>{it.text}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!data.items.length && <div className="text-sm mt-3">Nessuna lavorazione indicata.</div>}
        <NotesAndSignature />
      </div>
    </div>
  );
}
